import   React               ,
       { useState            ,
         useEffect            }  from "react";

import   classNames             from "classnames";

import   styles                 from "../purchaseManagment/Cart.module.scss";

import   Window                 from "../../widget/windows/window";
import   AnimatedWaitingIcon2   from "../../widget/animations/animatedWaitingIcon2";

import   BankChoice             from "../purchaseManagment/BankChoice";

import { createSubscription   }  from "../../../backendServices/subscriptionManagment/api";

import { openPaymentPopup     ,
         redirectPaymentPopup ,
         listenForPaymentResult ,
         PaymentResultStatus   }  from "../../../utils/utils_paymentPopup";
import { pollAdminRefreshAfterPurchase }  from "../../../utils/utils_pollAdminRefresh";

import { useTypedSelector     ,
         useTypedDispatch      }  from "../../../store/useTypeSelector";
import { closeSubscriptionPurchaseModal }  from "../../../store/subscriptionPurchaseModalManagment/actions";

// Pendant de QuotaPurchaseModal pour un achat en mode abonnement : même écran de choix
// de banque (BankChoice), même fenêtre à part pour la banque (utils_paymentPopup.ts,
// cf. QuotaPurchaseModal pour le pourquoi), mais createSubscription() au lieu de
// createPayment() — pas de panier à solder, la ressource et son prix viennent
// directement du catalogue (cf. utils_creatorCapacityPurchase.ts, branche isRecurring).
export const SubscriptionPurchaseModal: React.FC = () => {

  const dispatch = useTypedDispatch();

  const { open, productVariantCode, priceCode, label } = useTypedSelector((state) => state.subscriptionPurchaseModalReducer);
  const email = useTypedSelector((state) => state.authenticationReducer.authentication.admin?.email);

  const [ paying , setPaying ] = useState(false);
  const [ error  , setError  ] = useState('');
  const [ result , setResult ] = useState<PaymentResultStatus | null>(null);

  useEffect(() => {
    if (!open) return;

    return listenForPaymentResult((status) => {
      setPaying(false);
      setResult(status);

      // "success" ici ne veut dire qu'"approuvé" — le premier prélèvement (donc le
      // crédit réel du quota) arrive plus tard par webhook. Cf. utils_pollAdminRefresh.ts.
      if (status === 'success' && email) {
        pollAdminRefreshAfterPurchase(email);
      }
    });
  }, [open, email]);

  if (!open || productVariantCode === null || priceCode === null) {
    return null;
  }

  const close = () => {
    setError('');
    setResult(null);
    dispatch(closeSubscriptionPurchaseModal());
  };

  const handlePay = async (bankCode: string) => {
    if (!email) {
      setError("Impossible d'identifier le compte créateur.");
      return;
    }

    // Doit être appelé de façon SYNCHRONE (avant le await ci-dessous) : au-delà du
    // gestionnaire de clic direct, le navigateur bloque window.open().
    const popup = openPaymentPopup();

    if (!popup) {
      setError("Le navigateur a bloqué la fenêtre de paiement. Autorisez les popups pour ce site puis réessayez.");
      return;
    }

    setPaying(true);
    setError('');

    const response = await createSubscription(productVariantCode, priceCode, bankCode, email, label);

    if (response.code === 1) {
      redirectPaymentPopup(popup, response.payload);
    } else {
      popup.close();
      setError(response.comment || "Impossible de créer l'abonnement.");
      setPaying(false);
    }
  };

  if (result) {
    return (
      <Window
        message={<>{result === 'success' ? "Abonnement validé. Le premier prélèvement sera confirmé par votre banque dans les prochains instants." : "L'abonnement n'a pas abouti."}</>}
        messageType="information"
        onClickOnValidateButton={close}
        validButtonText="Fermer"
        zIndex={9995}
      />
    );
  }

  if (error) {
    return (
      <Window
        message={<>{error}</>}
        messageType="information"
        onClickOnValidateButton={close}
        validButtonText="Fermer"
        zIndex={9995}
      />
    );
  }

  return (
    <>
      <BankChoice onCancel={close} onValidate={handlePay} />

      {paying && (
        <div className={classNames(styles.overlay)}>
          <AnimatedWaitingIcon2 />
        </div>
      )}
    </>
  );
};

export default SubscriptionPurchaseModal;
